import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import '../styles/Register.css';

const Register = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    fullName: '',
    phone: '',
    password: '',
    confirmPassword: '',
    role: '',
    station: '',
    shift: ''
  });
  const [loading, setLoading] = useState(false);

  const stations = [
    { value: 'المعمل المركزي', label: 'المعمل المركزي' },
    { value: 'الفسطاط 17', label: 'الفسطاط 17' },
    { value: 'الملك الصالح 16', label: 'الملك الصالح 16' },
    { value: 'الروضة 15', label: 'الروضة 15' },
    { value: 'ميدان الجيزة 14', label: 'ميدان الجيزة 14' },
    { value: 'الجيزة 13', label: 'الجيزة 13' }
  ];

  const roles = [
    { value: 'engineer', label: 'مهندس' },
    { value: 'supervisor', label: 'سوبر فايزر' },
    { value: 'senior', label: 'سنيور' },
    { value: 'technician', label: 'فني' },
    { value: 'assistant', label: 'مساعد' }
  ];

  const shifts = [
    { value: 'نهار', label: 'نهار' },
    { value: 'ليل', label: 'ليل' }
  ];

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const validateForm = () => {
    if (!formData.fullName.trim()) {
      toast.error('الرجاء ادخال الاسم الثنائي');
      return false;
    }
    if (!formData.phone.trim()) {
      toast.error('الرجاء ادخال رقم الهاتف');
      return false;
    }
    if (!/^(010|011|012|015)\d{8}$/.test(formData.phone)) {
      toast.error('رقم الهاتف غير صحيح');
      return false;
    }
    if (!formData.password) {
      toast.error('الرجاء ادخال كلمة المرور');
      return false;
    }
    if (formData.password.length < 6) {
      toast.error('كلمة المرور يجب ان تكون 6 احرف على الاقل');
      return false;
    }
    if (formData.password !== formData.confirmPassword) {
      toast.error('كلمة المرور غير متطابقة');
      return false;
    }
    if (!formData.role) {
      toast.error('الرجاء اختيار الوظيفة');
      return false;
    }
    if (!formData.station) {
      toast.error('الرجاء اختيار المعمل');
      return false;
    }
    if (!formData.shift) {
      toast.error('الرجاء اختيار الشيفت');
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setLoading(true);

    try {
      const response = await fetch('/api/auth/register', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          phone: formData.phone,
          password: formData.password,
          fullName: formData.fullName,
          role: formData.role,
          station: formData.station,
          shift: formData.shift
        }),
      });

      const data = await response.json();

      if (response.ok) {
        toast.success('تم ارسال طلب التسجيل بنجاح');
        
        const roleLabel = roles.find(r => r.value === formData.role)?.label || formData.role;
        const whatsappMessage = `مرحبا، انا ${formData.fullName}
سجلت حساب جديد في نظام Metro4

رقم الهاتف: ${formData.phone}
الوظيفة: ${roleLabel}
المعمل: ${formData.station}
الشيفت: ${formData.shift}

ارجو الموافقة على حسابي للدخول الى النظام.`;
        
        const whatsappUrl = `https://wa.me/201000421394?text=${encodeURIComponent(whatsappMessage)}`;
        
        setTimeout(() => {
          window.open(whatsappUrl, '_blank');
        }, 1000);
        
        setTimeout(() => {
          navigate('/login');
        }, 2000);
      } else {
        toast.error(data.message || 'حدث خطا اثناء التسجيل');
      }
    } catch (err) {
      console.error('Registration error:', err);
      toast.error('حدث خطا في الاتصال بالسيرفر');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="register-container">
      <div className="register-box">
        <div className="register-header">
          <h1 className="register-title">تسجيل حساب جديد</h1>
          <p className="register-subtitle">ORASCOM CONSTRUCTION Laboratory</p>
          <p className="register-project">Metro Line 4 - Phase 1</p>
        </div>

        <div className="register-note">
          <i className="fas fa-info-circle"></i>
          <span>سجل رقمك المسجل لدى الشركة</span>
        </div>

        <form onSubmit={handleSubmit} className="register-form">
          <div className="form-group">
            <label htmlFor="fullName">
              <i className="fas fa-user"></i>
              الاسم الثنائي
            </label>
            <input
              type="text"
              id="fullName"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              placeholder="ادخل الاسم الثنائي"
              disabled={loading}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="phone">
              <i className="fas fa-phone"></i>
              رقم الهاتف
            </label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="01012345678"
              disabled={loading}
              maxLength="11"
              required
            />
            <small className="form-hint">المسجل لدى الشركة</small>
          </div>

          <div className="form-group">
            <label htmlFor="password">
              <i className="fas fa-lock"></i>
              كلمة المرور
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="ادخل كلمة المرور"
              disabled={loading}
              required
            />
            <small className="form-hint">6 احرف على الاقل</small>
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword">
              <i className="fas fa-lock"></i>
              تاكيد كلمة المرور
            </label>
            <input
              type="password"
              id="confirmPassword"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              placeholder="اعد ادخال كلمة المرور"
              disabled={loading}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="role">
              <i className="fas fa-briefcase"></i>
              الوظيفة
            </label>
            <select
              id="role"
              name="role"
              value={formData.role}
              onChange={handleChange}
              disabled={loading}
              required
            >
              <option value="">اختر الوظيفة</option>
              {roles.map((role) => (
                <option key={role.value} value={role.value}>
                  {role.label}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="station">
              <i className="fas fa-building"></i>
              المعمل
            </label>
            <select
              id="station"
              name="station"
              value={formData.station}
              onChange={handleChange}
              disabled={loading}
              required
            >
              <option value="">اختر المعمل</option>
              {stations.map((station) => (
                <option key={station.value} value={station.value}>
                  {station.label}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="shift">
              <i className="fas fa-clock"></i>
              الشيفت
            </label>
            <select
              id="shift"
              name="shift"
              value={formData.shift}
              onChange={handleChange}
              disabled={loading}
              required
            >
              <option value="">اختر الشيفت</option>
              {shifts.map((shift) => (
                <option key={shift.value} value={shift.value}>
                  {shift.label}
                </option>
              ))}
            </select>
          </div>

          <button type="submit" className="register-button" disabled={loading}>
            {loading ? (
              <>
                <i className="fas fa-spinner fa-spin"></i>
                جاري التسجيل...
              </>
            ) : (
              <>
                <i className="fas fa-user-plus"></i>
                تسجيل حساب جديد
              </>
            )}
          </button>

          <div className="login-link">
            <span>لديك حساب؟</span>
            <button
              type="button"
              onClick={() => navigate('/login')}
              disabled={loading}
              className="link-button"
            >
              تسجيل الدخول
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Register;